import { EntityRequestTmppay } from "../../entity/EntityRequestTmppay";

export class DtoRequestTmppaysPostRes extends EntityRequestTmppay {}
